/**
 * Platform delays API client.
 *
 * Provides methods for managing platform-specific SEO delays.
 */

import { api } from './client';
import type {
  PlatformDelay,
  ApiResponse,
  UpdatePlatformDelayRequest,
} from '../types';

/**
 * Platform delays API endpoints.
 */
export const platformDelaysApi = {
  /**
   * List all platform delays for a site.
   */
  list: (siteSlug: string) =>
    api.get<ApiResponse<PlatformDelay[]>>(`/v1/sites/${siteSlug}/platform-delays`),

  /**
   * Update a platform delay.
   */
  update: (siteSlug: string, platform: string, data: UpdatePlatformDelayRequest) =>
    api.put<ApiResponse<PlatformDelay>>(`/v1/sites/${siteSlug}/platform-delays/${platform}`, data),

  /**
   * Reset a platform delay to default.
   */
  reset: (siteSlug: string, platform: string) =>
    api.delete<ApiResponse<PlatformDelay>>(`/v1/sites/${siteSlug}/platform-delays/${platform}`),
};
